












import { Sort } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class SortList extends Vue {
  @Prop({ required: true })
  sorts: Sort[];

  @Prop()
  selectedSort: Sort;

  onSortClick(sort: Sort) {
    this.$x.emit(EVENTS.SortClicked, sort);
  }
}
